/* Course */
export const GET_COURSE = "GET_COURSE"
export const GET_COURSE_SUCCESS = "GET_COURSE_SUCCESS"
export const GET_COURSE_CLEAN = "GET_COURSE_CLEAN"
export const API_ERROR = "API_ERROR"
